export const CRITERIA_LIST = "CriteriaList"
export const CRITERION_SCORE_LIST = "CriterionScoreList"

export const SUB_CRITERIA_LIST = "SubCriteriaList"
export const SUB_CRITERION_PARAM_VALUES_LIST = "SubCriterionParamValuesList"

export const ENERGY_CARRIERS_LIST = "EnergyCarriersList"
export const MATERIALS_LIST = "MaterialsList"

export const PROJECTS_LIST = "ProjectsList"
export const PROJECT_VERSIONS_LIST = "ProjectVersionsList"
export const PROJECT_VERSION_ENERGY_CARRIERS_LIST = "ProjectVersionEnergyCarriersList"
export const PROJECT_VERSION_MATERIALS_GRID = "ProjectVersionMaterialsList"
export const PROJECT_MATERIAL_GRID = "ProjectMaterialsList"

export const PROJECT_VERSION_RECYCLABLE_MATERIALS_LIST = "ProjectMaterialListRecyclable"
export const PROJECT_VERSION_EPD_CERTIFIED_MATERIALS_LIST = "ProjectMaterialListEPDCertified";
export const PROJECT_VERSION_WOOD_BASED_MATERIALS_GRID = "ProjectMaterialListWoodBasedCertified"
export const PROJECT_VERSION_AREA_ZELPO_GRID = "ProjectVersionAreaListZELPO";
export const PROJECT_VERSION_AREA_ZELZP_GRID = "ProjectVersionAreaListZELZP";
export const PROJECT_VERSION_AREA_ZELST_GRID = "ProjectVersionAreaListZELST";
export const PROJECT_VERSION_AREA_ZELZF_GRID = "ProjectVersionAreaListZELZF";
export const PROJECT_VERSION_AREA_ZELZS_GRID = "ProjectVersionAreaListZELZS";
export const PROJECT_VERSION_AREA_VPREP_GRID = "ProjectVersionAreaListVPREP";
export const PROJECT_VERSION_AREA_PEFKE_GRID = "ProjectVersionAreaListVPREP";

export const LIFESPAN_LIST = "LifespanList"

export const PROJECT_VERSION_ROOM_TYPES_LIST = "ProjectVersionRoomTypesList"
export const PROJECT_VERSION_ROOM_CATEGORIES_LIST = "ProjectVersionRoomCategoriesList"
export const PROJECT_VERSION_ROOMS_LIST = "ProjectVersionRoomList"

export const MATERIAL_USAGE_GROUPS_LIST = "MaterialUsageGroupsList"

export const AREA_LIST = "AreaList"
export const PROJECT_VERSION_AREA_LIST = "ProjectVersionAreaList"
export const PROJECT_VERSION_DOOR_LIST = "ProjectVersionDoorList"
export const PROJECT_VERSION_WINDOW_LIST = "ProjectVersionWindowList"
export const PROJECT_VERSION_LOP_LIST = "ProjectVersionLopList"
export const PROJECT_VERSION_TREE_LIST = "ProjectVersionTreeList"

export const PROJECT_VERSION_LOP_FILLINGS_GRID = "ProjectVersionLopFillings"
export const PROJECT_VERSION_LOP_PROFILES_GRID = "ProjectVersionLopProfiles"
export const PROJECT_VERSION_PARKING_GRID = "ProjectVersionParkingList"

export const PROJECT_RUNOFF_COEFFICIENT_GRID = "ProjectVersionRunoffCoefficientGrid"
export const PROJECT_VERSION_CAPACITIES_GRID = "ProjectVersionCapacityList"




// WEBPACK FOOTER //
// ./src/sbtool/gridsContants.ts